export function convertPicksToHeightInMeter(picks: number, pickDensityInPicksPerMeter: number): number {
  return pickDensityInPicksPerMeter > 0.0 ? picks / pickDensityInPicksPerMeter : 0.0;
}
